import React from "react";
import { connect } from "react-redux";
import { isA } from "../../store/utility";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";

import { Tabs, Tab } from "react-bootstrap";
import Contacts from "../Contact/Contacts";
import Sections from "../Section/Sections";
import Companies from "../Company/Companies";
import Users from "../Users/Users";
// 24/10/2026 : projets du planning (SOPlanning)
import PlanningProjects from "./PlanningProjects";
import CallDoneTemplate from "./CallDoneTemplate"; // 03/11/2026 (registre n° 38)
import axios from "../../axios-atis";
import {
  fetchCompanies,
  fetchContacts,
  fetchSections,
  updtContact,
  updtSection,
  updtCompany,
  addContact,
  addSection,
  addCompany,
  addUser,
  updateUser,
} from "../../store/actions/index";
import Notification from "../../components/UI/Widget/Notification";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";

class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      userId: null,
      company: null,
      companies: null,
      companyError: null,
      contacts: null,
      contactError: null,
      sections: null,
      sectionError: null,
    };
  }
  //LifeCycle
  componentWillReceiveProps(nextProps) {
    //console.log("componentWillReceiveProps : ", nextProps)
    if (
      this.props.loading !== nextProps.loading ||
      this.props.contacts !== nextProps.contacts ||
      this.props.sections !== nextProps.sections ||
      this.props.companies !== nextProps.companies 
    ) {
      const _companies = nextProps.companies.sort((a, b) => { return a.name.trim().localeCompare(b.name.trim()) });
      this.setState({
        contacts: nextProps.contacts,
        sections: nextProps.sections,
        companies: _companies,
        loading: nextProps.loading
      });
    }
    if (nextProps.sectionError !== null) {
      //console.log(nextProps.sectionError)
      this.setState({
        sectionError: nextProps.sectionError
      });
    }
    if (nextProps.contactError !== null) {
      //console.log(nextProps.contactError)
      this.setState({
        contactError: nextProps.contactError
      });
    }
    if (nextProps.companyError !== null) {
      //console.log(nextProps.companyError);
      this.setState({
        companyError: nextProps.companyError
      });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.loading !== this.props.loading ||
      nextProps.contacts !== this.props.contacts ||
      nextProps.contactError !== this.props.contactError ||
      nextProps.sections !== this.props.sections ||
      nextProps.sectionError !== this.props.sectionError ||
      nextProps.companies !== this.props.companies ||
      nextProps.companyError !== this.props.companyError 
    );
  }

  componentDidMount() {
    this.props.dispatch(fetchContacts());
    this.props.dispatch(fetchSections());
    this.props.dispatch(fetchCompanies());
  }

  saveOrUpdateSection = section => {
    if (section.id === null) {
      this.props.dispatch(addSection(section));
    } else {
      this.props.dispatch(updtSection(section));
    }
  };

  saveOrUpdateContact = contact => {
    if (contact.id === null) {
      this.props.dispatch(addContact(contact));
    } else {
      this.props.dispatch(updtContact(contact));
    }
  };

  saveOrUpdateCompany = company => {
    if (company.id === null) {
      this.props.dispatch(addCompany(company));
    } else {
      this.props.dispatch(updtCompany(company));
    }
  };

  saveOrUpdateUser = user => {
    if (user.id == null) {
      this.props.dispatch(addUser(user));
    } else {
      this.props.dispatch(updateUser(user));
    }
  };

  render() {
    const { company, contacts, sections, companies, error } = this.props;
    
    if (contacts === null || sections === null || this.state.loading) {
      return (<div align="center">
        <Loader type="ThreeDots" color="#00BFFF" height="100" width="100" />
      </div>);
    }
    return (
      <div className="content-wrapper">
        {error ?
          (<Notification
            message={error}
            notificationType={toast.TYPE.ERROR}
          />)
          : null
        }
        {this.state.sectionError !== null ? (
          <Notification
            message={this.state.sectionError.message}
            notificationType={toast.TYPE.ERROR}
          />
        ) : null}
        {this.state.contactError !== null ? (
          <Notification
            message={this.state.contactError.message}
            notificationType={toast.TYPE.ERROR}
          />
        ) : null}
        <div className="form-group content-heading">Paramètres</div>
        <Tabs id="settings-tab">
          <Tab eventKey={1} title="Contacts">
            <Contacts
              data={contacts}
              companies={companies}
              company={company}
              saveOrUpdate={contact => this.saveOrUpdateContact(contact)}
            />
          </Tab>
          <Tab eventKey={2} title="Sites">
            <Sections
              data={sections}
              companies={companies}
              company={company}
              saveOrUpdate={section => this.saveOrUpdateSection(section)}
            />
          </Tab>
          {isA() ? (
            <Tab eventKey={3} title="Compagnies">
              <Companies
                data={companies}
                saveOrUpdate={clientCompany => this.saveOrUpdateCompany(clientCompany)}
              />
              </Tab>
          ) : null}
          {isA() ? (
            <Tab eventKey={4} title="Utilisateurs">
              <Users
                saveOrUpdate={user => this.saveOrUpdateUser(user)}
              />
            </Tab>
          ) : null}
          {isA() ? (
            <Tab eventKey={5} title="Projets planning">
              <PlanningProjects />
            </Tab>
          ) : null}
          {isA() ? (
            <Tab eventKey={6} title="Message laissé">
              <CallDoneTemplate />
            </Tab>
          ) : null}
        </Tabs>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading:
      state.company.loading && state.contact.loading && state.section.loading,
    userId: state.auth.userId,
    company: state.auth.company,
    contacts: state.contact.contacts,
    sections: state.section.sections,
    companies: state.company.companies,
    contactError: state.contact.error,
    sectionError: state.section.error,
    companyError: state.company.error
  };
};

export default connect(mapStateToProps)(withErrorHandler(Settings, axios));



// WEBPACK FOOTER //
// ./src/containers/Settings/Settings.js